const maximumScaling = 6;

/**
 * Масштабирование больших таблиц
 */
function scaleLargeTables($this) {
	var contentWidth = $this.parent().innerWidth();
	var $table = $this.find('table');
	for (var i = 1; $table.width() > contentWidth && i < maximumScaling; i++) {
		$this.addClass('table--scale-' + i).removeClass('table--scale-' + (i - 1));
	}
}

/**
 * Инициализация ячеек выделенных столбцов
 */
function initStrongColCells($this) {
	var $table = $this.find('table');
	// $table.find('thead tr')
}

$(document).ready(function () {
	$('.table').each(function (index, el) {
		var $this = $(this);

		$this.append('<div class="table__tools js-buttons"></div>');

		if (!$this.hasClass('table--no-xls')) {
			$this.addExcelExport();
		}

		if (!$this.hasClass('table--no-zoom')) {
			$this.addZoomIn('table', 'table');
		}

		scaleLargeTables($this);
		// initStrongColCells($this);
	});
});



/** WEBPACK FOOTER **
 ** ./frontend/components/tables/tables.js
 **/